import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  validationRequiredLogin: {
    id: 'components.signup.validation.required.login',
    defaultMessage: 'Login is a required field',
  },
  validationRequiredEmail: {
    id: 'components.signup.validation.required.email',
    defaultMessage: 'Email is a required field',
  },
  validationEmail: {
    id: 'components.signup.validation.email',
    defaultMessage: 'This must be a valid email address',
  },
  validationRequiredPassword: {
    id: 'components.signup.validation.required.password',
    defaultMessage: 'Password is a required field',
  },
  validationMinLengthPassword: {
    id: 'components.signup.validation.min.length.password',
    defaultMessage: 'Password must be at least 8 characters',
  },
  placeholderLogin: {
    id: 'components.signup.form.placeholder.login',
    defaultMessage: 'Login',
  },
  placeholderEmail: {
    id: 'components.signup.form.placeholder.email',
    defaultMessage: 'Email',
  },
  placeholderPassword: {
    id: 'components.signup.form.placeholder.password',
    defaultMessage: 'Password',
  },
  loginButton: {
    id: 'components.signup.form.loginButton',
    defaultMessage: 'Login',
  },
  loginText: {
    id: 'components.signup.form.loginText',
    defaultMessage: 'Or if you already registered',
  },
  signupButton: {
    id: 'components.signup.form.signupButton',
    defaultMessage: 'Submit',
  },
  successText: {
    id: 'components.signup.form.successText',
    defaultMessage: "<strong>Thank You</strong><br /><br />You've just been sent an email<br />to confirm your email address.<br />Please click on the link in this email",
  },
});



// WEBPACK FOOTER //
// ./src/components/Signup/messages.js